export { default as detection } from './detection';

export default {
  detection: () => import('./detection'),
};
